import {
  initialState,
  Actions,
  State,
  GET_STATICS_PAGO,
  GET_STATICS_PAGO_SUCCESS,
  GET_STATICS_PAGO_ERROR,
  RESET_GET_STATICS_PAGO,
} from "../../types/pago/statics";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_STATICS_PAGO:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_STATICS_PAGO_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_STATICS_PAGO_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_STATICS_PAGO:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
